__turbopack_context__.v({
  "arrowIcon": "IntegrationCarousel-module__Ld1PnG__arrowIcon",
  "backgroundGlow": "IntegrationCarousel-module__Ld1PnG__backgroundGlow",
  "badge": "IntegrationCarousel-module__Ld1PnG__badge",
  "badgeDot": "IntegrationCarousel-module__Ld1PnG__badgeDot",
  "cardGlow": "IntegrationCarousel-module__Ld1PnG__cardGlow",
  "cardGlowPulse": "IntegrationCarousel-module__Ld1PnG__cardGlowPulse",
  "cardHeader": "IntegrationCarousel-module__Ld1PnG__cardHeader",
  "carouselContainer": "IntegrationCarousel-module__Ld1PnG__carouselContainer",
  "carouselStage": "IntegrationCarousel-module__Ld1PnG__carouselStage",
  "description": "IntegrationCarousel-module__Ld1PnG__description",
  "dot": "IntegrationCarousel-module__Ld1PnG__dot",
  "dotActive": "IntegrationCarousel-module__Ld1PnG__dotActive",
  "dots": "IntegrationCarousel-module__Ld1PnG__dots",
  "featureIcon": "IntegrationCarousel-module__Ld1PnG__featureIcon",
  "featureItem": "IntegrationCarousel-module__Ld1PnG__featureItem",
  "featureSlideIn": "IntegrationCarousel-module__Ld1PnG__featureSlideIn",
  "features": "IntegrationCarousel-module__Ld1PnG__features",
  "glowOrb1": "IntegrationCarousel-module__Ld1PnG__glowOrb1",
  "glowOrb2": "IntegrationCarousel-module__Ld1PnG__glowOrb2",
  "headerText": "IntegrationCarousel-module__Ld1PnG__headerText",
  "learnMore": "IntegrationCarousel-module__Ld1PnG__learnMore",
  "logoContainer": "IntegrationCarousel-module__Ld1PnG__logoContainer",
  "logoRing": "IntegrationCarousel-module__Ld1PnG__logoRing",
  "logoRing2": "IntegrationCarousel-module__Ld1PnG__logoRing2",
  "navButton": "IntegrationCarousel-module__Ld1PnG__navButton",
  "navigation": "IntegrationCarousel-module__Ld1PnG__navigation",
  "orbFloat1": "IntegrationCarousel-module__Ld1PnG__orbFloat1",
  "orbFloat2": "IntegrationCarousel-module__Ld1PnG__orbFloat2",
  "particle": "IntegrationCarousel-module__Ld1PnG__particle",
  "particleFloat": "IntegrationCarousel-module__Ld1PnG__particleFloat",
  "particlesContainer": "IntegrationCarousel-module__Ld1PnG__particlesContainer",
  "partnerLogo": "IntegrationCarousel-module__Ld1PnG__partnerLogo",
  "partnerName": "IntegrationCarousel-module__Ld1PnG__partnerName",
  "partnerTagline": "IntegrationCarousel-module__Ld1PnG__partnerTagline",
  "progressBar": "IntegrationCarousel-module__Ld1PnG__progressBar",
  "progressContainer": "IntegrationCarousel-module__Ld1PnG__progressContainer",
  "pulse": "IntegrationCarousel-module__Ld1PnG__pulse",
  "ringPulse": "IntegrationCarousel-module__Ld1PnG__ringPulse",
  "section": "IntegrationCarousel-module__Ld1PnG__section",
  "sectionHeader": "IntegrationCarousel-module__Ld1PnG__sectionHeader",
  "slide": "IntegrationCarousel-module__Ld1PnG__slide",
  "slideActive": "IntegrationCarousel-module__Ld1PnG__slideActive",
  "slideCard": "IntegrationCarousel-module__Ld1PnG__slideCard",
  "subtitle": "IntegrationCarousel-module__Ld1PnG__subtitle",
  "title": "IntegrationCarousel-module__Ld1PnG__title",
  "trustDivider": "IntegrationCarousel-module__Ld1PnG__trustDivider",
  "trustItem": "IntegrationCarousel-module__Ld1PnG__trustItem",
  "trustLabel": "IntegrationCarousel-module__Ld1PnG__trustLabel",
  "trustSection": "IntegrationCarousel-module__Ld1PnG__trustSection",
  "trustValue": "IntegrationCarousel-module__Ld1PnG__trustValue",
});
